<template>
    <div>
        <span class="badge bg-primary text-light p-2">Steg 1</span>

        <div class="form-row align-items-center mt-3">

            <div class="col-auto">
                <label class="m-0" for="postcode">
                    {{ dictionary.deliveryPostcode }}
                </label>
            </div>

            <div class="col-auto">
                <postcode-field v-model="postcode"
                                @validated="onValidate"></postcode-field>
            </div>

            <div class="col-auto">
                <button class="btn"
                        type="button"
                        :class="valid ? 'btn-secondary' : 'btn-outline-light'"
                        :disabled="!valid || saving"
                        v-on:click="save">
                    {{ dictionary.save }}
                    <div v-if="saving"
                         class="spinner-border spinner-border-sm align-middle text-light ml-2"
                         role="status">
                        <span class="sr-only">{{ dictionary.loading }}</span>
                    </div>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import { GetTranslations } from "../services/translation.service";
import PostcodeField from "./postcode-field.vue";

export default {
  name: "PostcodePicker",
  props: {
    currentPostcode: {
      type: String,
      required: false,
    },
    saving: {
      type: Boolean,
      required: false
    },
  },
  data() {
    return {
      valid: false,
      postcode: this.currentPostcode,
      dictionary: GetTranslations("postcode"),
    };
  },
  methods: {
    onValidate: function (isValid) {
      this.valid = isValid;
    },
    save: function () {
      let { postcode } = this;
      this.$emit("save", postcode);
    },
  },
  components: {
    PostcodeField,
  },
};
</script>